/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  (function () {
    const observer = new MutationObserver(() => {
      document
        .querySelectorAll(".tolstoy-tile-name-container")
        .forEach((el) => {
          if (el.innerHTML.includes("&lt;b&gt;")) {
            el.innerHTML = el.innerHTML
              .replace(/&lt;b&gt;/g, "<b>")
              .replace(/&lt;\/b&gt;/g, "</b>");
          }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
